import React, { Component } from 'react';
import { Menu, Icon, Button } from 'antd';
import "./NavBar.css"
class NavBar extends Component {
    render() {
        return (
            <div className="NavBar">
                {/* <Menu defaultSelectedKeys={['grid']} mode="horizontal" onClick={(e) => this.props.setMode(e.key)}>
                    <Menu.Item key={"grid"}>
                        <Icon type="number" />
                        GRID
                    </Menu.Item>
                    <Menu.Item key={"lasso"}>
                        <Icon type="gateway" />
                        LASSO
                    </Menu.Item>
                </Menu> */}
                <Button.Group size={"large"}>
                    <Button type={this.props.mode=="grid"?'primary':'default'} onClick={() => this.props.setMode("grid")}>
                        <Icon type="number" />
                        GRID
                    </Button>
                    <Button type={this.props.mode=="lasso"?'primary':'default'} onClick={() => this.props.setMode("lasso")}>
                        <Icon type="gateway" />
                        LASSO
                    </Button>
                </Button.Group>
            </div>
        )
    }
}

export default NavBar;